import React from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import AnaliseComparativaTab from './AnaliseComparativaTab'
import ComissoesTab from './ComissoesTab'
import ExtratosContaTab from './ExtratosContaTab'
import { MODULE_NAME, PERM_LOADING, tabButtonClass } from './financeiroPelUi'

type ActiveTab = 'comissoes' | 'extratosConta' | 'analiseComparativa'

const PeL: React.FC = () => {
  const [moduleTitle, setModuleTitle] = React.useState('Financeiro P&L')
  const [moduleDescription, setModuleDescription] = React.useState(
    'Processamento e consulta de extratos de comissões e contas'
  )
  const [activeTab, setActiveTab] = React.useState<ActiveTab>('comissoes')

  React.useEffect(() => {
    const loadModule = async () => {
      const result = await modulesService.getByName(MODULE_NAME)
      if (result.success && result.data) {
        if (result.data.display_name) setModuleTitle(result.data.display_name)
        if (result.data.description) setModuleDescription(result.data.description)
      }
    }
    void loadModule()
  }, [])

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
      <PermissionGuard
        moduleName={MODULE_NAME}
        permissionType="show"
        loadingComponent={PERM_LOADING}
        fallback={
          <div className="flex flex-1 items-center justify-center">
            <div className="text-center">
              <Text size="xl" className="mb-2 text-gray-500 dark:text-gray-400">
                Acesso Negado
              </Text>
              <Text size="sm" color="muted">
                Você não tem permissão para acessar esta página.
              </Text>
            </div>
          </div>
        }
      >
        <div className="py-6 px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
              {moduleTitle}
            </Heading>
            <Text size="sm" color="muted" className="mt-2">
              {moduleDescription}
            </Text>
          </div>

          <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
            <nav className="-mb-px flex flex-wrap gap-x-8 gap-y-2" aria-label="Abas do P&L">
              <button
                type="button"
                onClick={() => setActiveTab('comissoes')}
                className={tabButtonClass(activeTab === 'comissoes')}
              >
                Extrato Comissões Icatu
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('extratosConta')}
                className={tabButtonClass(activeTab === 'extratosConta')}
              >
                Extratos por conta
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('analiseComparativa')}
                className={tabButtonClass(activeTab === 'analiseComparativa')}
              >
                Análise comparativa
              </button>
            </nav>
          </div>

          {activeTab === 'comissoes' && <ComissoesTab />}
          {activeTab === 'extratosConta' && <ExtratosContaTab />}
          {activeTab === 'analiseComparativa' && <AnaliseComparativaTab />}
        </div>
      </PermissionGuard>
    </div>
  )
}

export default PeL
